import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'eview-chart',
  templateUrl: 'chart.component.html',
  styleUrls: ['chart.component.scss']
})
export class ChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() data: any;
  @Input() type: any;
  @Input() id: string;
  @Input() options: any;
  @ViewChild('mychart', { static: false }) canvasRef?: ElementRef<HTMLCanvasElement>;

  mychart: any;
  legends: any;
  legendColors: any;
  private viewReady = false;
  private retryTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.viewReady) {
      this.scheduleInit();
    }
  }

  ngAfterViewInit() {
    this.viewReady = true;
    this.scheduleInit();
  }

  ngOnDestroy() {
    this.clearRetry();
    this.destroyChart();
  }

  private scheduleInit() {
    this.clearRetry();
    // Defer one frame so *ngIf layouts + canvas get real size before Chart.js binds
    this.retryTimer = setTimeout(() => this.initializeChart(), 0);
  }

  private clearRetry() {
    if (this.retryTimer != null) {
      clearTimeout(this.retryTimer);
      this.retryTimer = null;
    }
  }

  private destroyChart() {
    if (this.mychart) {
      try {
        this.mychart.destroy();
      } catch {
        /* ignore */
      }
      this.mychart = null;
    }
  }

  initializeChart() {
    if (!this.data) {
      return;
    }

    const canvas =
      this.canvasRef?.nativeElement ||
      (this.id ? (document.getElementById(this.id) as HTMLCanvasElement) : null);

    if (!canvas) {
      // Canvas not in DOM yet (race with parent *ngIf) — retry shortly
      this.retryTimer = setTimeout(() => this.initializeChart(), 50);
      return;
    }

    if (this.data?.data?.labels) {
      this.legends = this.data.data.labels;
      this.legendColors = this.data.data.datasets?.[0]?.backgroundColor;
    }

    if (this.data.options === undefined) {
      this.data.options = {
        legend: {
          display: false,
          position: 'top'
        }
      };
    }

    if (!this.data.data) {
      return;
    }

    this.destroyChart();
    this.mychart = new Chart(canvas, {
      type: this.type,
      data: this.data.data,
      options:
        typeof this.data.options !== 'undefined' ? this.data.options : null
    });
  }
}
